import React, { useContext } from "react";
import {
	List,
	ListItem,
	ListItemAvatar,
	Avatar,
	ListItemText,
	Typography,
	Box,
} from "@mui/material";
import { CreatorContext } from "../../context/CreatorContext";
import Ann from "../../assets/showcases/ann.jpeg";
import Kim from "../../assets/showcases/kim.jpg";
import John from "../../assets/showcases/john.jpg";

const ShowcaseWorker = () => {
	const { creator } = useContext(CreatorContext);
	const employeesData = [
		{
			name: "Ann",
			avatar: Ann,
		},
		{ name: "Kim", avatar: Kim },
		{ name: "John", avatar: John },
	];
	return (
		<Box
			sx={{
				width: "100%",
				display: "flex",
				flexDirection: "column",
				gap: 1.5,
				padding: 2,
				"& *": {
					fontFamily: creator.fontFamilyCap + "!important",
				},
				backgroundColor: creator.themeColor,
				color: creator.themeMode === "Dark" ? "#ffffff" : "#000000",
			}}
		>
			{employeesData.map((employee, index) => (
				<Box
					sx={{
						width: "100%",
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
						gap: 1,
					}}
				>
					<Avatar
						src={employee.avatar}
						alt={employee.name}
						sx={{ width: 30, height: 30 }}
					/>
					<Typography sx={{ fontSize: "10px" }}>{employee.name}</Typography>
				</Box>
			))}
		</Box>
	);
};

export default ShowcaseWorker;
